import { provider } from './store';
import { AgreementConfigsDesktop } from './desktop';

export const AgreementConfigsView = provider( () => {
    return <>
        <AgreementConfigsDesktop />
    </>;
}, { keepAlive: true } );
